import gql from "graphql-tag";

export default gql`
  mutation CreateWorkOrder(
    $title: String
    $description: String
    $dueDate: String
    $time: String
    $startDate: String
    $endDate: String
    $interval: String
    $isRecurring: Boolean
    $recurrence: String
    $recurrenceDates: [String!]
    $priority: Priority
    $status: WorkOrderStatus
    $siteId: ID
    $assignedToId: ID
    $additionalWorkersIds: [ID!]
    $companyId: ID
  ) {
    createWorkOrder(
      title: $title
      description: $description
      dueDate: $dueDate
      time: $time
      startDate: $startDate
      endDate: $endDate
      interval: $interval
      isRecurring: $isRecurring
      recurrence: $recurrence
      recurrenceDates: $recurrenceDates
      priority: $priority
      status: $status
      siteId: $siteId
      assignedToId: $assignedToId
      additionalWorkersIds: $additionalWorkersIds
      companyId: $companyId
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/CreateWorkOrder.ts